import React from 'react';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import { AlertsInformativos } from '../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../commons/texts';
import { Divider } from '@mui/material';

export const OrdenesServicio = () => {
  return (
    <>
      <BreadCrumbsAndTitle
        title="Ordenes de servicio"
        mainModule="ordenes de servicio"
        parent="Ordenes de servicio"
        action=""
      />
      <AlertsInformativos type="info" title="info" content={alertInformativo.ordenesServicios} />
      <Divider sx={{ marginBottom: 5 }} />
    </>
  );
};
